export class FidelityLogger {
  constructor(axiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  logFidelityCardCreationInitiated(userId, storeId) {
    try {
      this.axiosInstance.post('/user/fidelity-card/creation-initiated', {
        userId,
        storeId,
      });
    } catch (error) {
      console.error('Failed to log fidelity card creation click', error);
    }
  }
}
